module.exports = __webpack_public_path__ + "static/NotoSans-Regular.subset-f5951f6acaab684c1e05b1414714955b.woff";